import { LayoutGrid, List, Image } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export type LayoutType = 'grid' | 'list' | 'gallery';

interface LayoutSwitcherProps {
  currentLayout: LayoutType;
  onLayoutChange: (layout: LayoutType) => void;
}

const LayoutSwitcher = ({ currentLayout, onLayoutChange }: LayoutSwitcherProps) => {
  const layouts = [
    { type: 'grid', icon: LayoutGrid },
    { type: 'list', icon: List },
    { type: 'gallery', icon: Image },
  ] as const;

  return (
    <div className="flex gap-2">
      {layouts.map(({ type, icon: Icon }) => (
        <Button
          key={type}
          variant="ghost"
          size="icon"
          onClick={() => onLayoutChange(type)}
          className={cn(
            'hover:bg-muted',
            currentLayout === type && 'bg-muted'
          )}
        >
          <Icon className="h-4 w-4" />
        </Button>
      ))}
    </div>
  );
};

export default LayoutSwitcher;